import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {
  getAllBusinessWorkOrderTypes,
  setSelectedWorkOrderType,
  getWorkOrderForm,
  setSelectedSubject,
  pushToHistory,
} from '../BusinessWorkOrderSystemSlice';
import {hideAppLoader} from 'app/Components/Shared/Loader/LoaderSlice';
import useExtendedEffect from 'app/utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from 'app/utilities/hooks/useClearStateResetFlag';
import {BusinessWorkOrderSystemStep} from '../Constant/Constant';
import ReactSelect from 'app/Components/Shared/ReactSelect/ReactSelect';
import SelectOptionButton from 'app/Components/Shared/SelectOptionButton/SelectOptionButton';
import BtnNextStep from '../BtnNextStep';
import {isNullOrEmpty} from 'app/utilities/StringHelpers/StringHelpers';

const WorkOrderTypeSelecting = (props) => {
  const [fuTypesOptions, setFuTypesOptions] = useState(props.data?.workOrderTypes?.[props.data?.selectedSubject] ?? []);
  const [error, setError] = useState(false);

  useEffect(() => {
      if(isNullOrEmpty(props.data.workOrderTypes)){
        props.getAllBusinessWorkOrderTypes()
      }
  }, []);

  useEffect(() => {
    if (props.data.selectedSubject && props.data.workOrderTypes && props.data.workOrderTypes[props.data.selectedSubject]) {
      getSelectedSubjectFuTypes(props.data.selectedSubject);
    }
  }, [props.data.workOrderTypes, props.data.selectedSubject]);

  function getSelectedSubjectFuTypes(subject) {
    const subjectFuTypes = props.data.workOrderTypes[subject];
    const buttons = [];
    subjectFuTypes.forEach((item) => {
      buttons.push({
        id: item.fuType,
        label: item.fuTypeDescription,
        value: {...item, type: item.fuType, description: item.fuTypeDescription},
        selected: item.fuType === props.data.selectedWorkOrderType?.type ? true : false,
      });
    });
    setFuTypesOptions(buttons);
    props.setSelectedSubject(subject);
  }

  async function nextStep() {
    var canContinue = false;
    if (props.data.selectedWorkOrderType) {
      await props.getWorkOrderForm({fuType: props.data.selectedWorkOrderType.type, orgId: props.portalsBlock.selectedHetPay}).then(() => {
        canContinue = true;
      });
    } else {
      canContinue = false;
    }
    setError(!canContinue);
    return canContinue ? BusinessWorkOrderSystemStep.WorkOrderForm : null;
  }


  return (
    <div className='business-work-order-system_select_wo_type'>
      <div className='l-title'>פניה חדשה - {props.portalsBlock.selectedOrgName} </div>
      <div className='m-title center'>מה תרצו לבצע?</div>
      <ReactSelect
        getOptionLabel={(option) => option.key}
        getOptionValue={(option) => option.key}
        placeholder='סוג הפניה'
        value={props.data.selectedSubject ? {key: props.data.selectedSubject, value: props.data.selectedSubject} : null}
        name='selected'
        options={Object.keys(props.data.workOrderTypes || {}).map((key) => ({key: key, value: key}))}
        onChange={(e) => {
          getSelectedSubjectFuTypes(e.key);
          props.setSelectedWorkOrderType(null);
        }}
      />
      {props.data.selectedSubject && (
        <div className=''>
          <SelectOptionButton
            title={'נושא הפניה'}
            buttonsData={fuTypesOptions}
            onClick={(val) => {
              props.setSelectedWorkOrderType(val);
              setError(false);
            }}
          />
        </div>
      )}
        <BtnNextStep onClick={nextStep}
         text={'בחרתי, אפשר להמשיך'}
         error={error} errorText={'כדי להמשיך יש לבחור את סוג הפעולה'}
         />
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.businessWorkOrderSystem,
  portalsBlock: state.portalsBlock,
});
const mapDispatchToProps = {
  getAllBusinessWorkOrderTypes,
  setSelectedWorkOrderType,
  getWorkOrderForm,
  setSelectedSubject,
  pushToHistory,
  hideAppLoader,
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkOrderTypeSelecting);
